import service from "@/tools/request";
import defaultRequestErrorHandle from "@/plug/request/defaultErrorHandle";

export function reportInfo({
  search,
  institution_id,
  phone,
  name,
  type
}) {
  return service({
    url: '/reportInfo',
    method: 'post',
    data: {
      search,
      institution_id,
      phone,
      name,
      type
    }
  }).catch(defaultRequestErrorHandle)
}

export function getAllReport({
  phone
}) {
  return service({
    url: '/getAllReport',
    method: 'post',
    data: {
      phone
    }
  }).catch(defaultRequestErrorHandle)
}

export function getReportInfo({
  exam_id
}) {
  return service({
    url: '/getReportInfo',
    method: 'post',
    data: {
      exam_id
    }
  }).catch(defaultRequestErrorHandle)
}

export function makeReportLink({
  url,
  overdueTime,
  examId,
  phone,
  report,
  study_id
}) {
  return service({
    url: '/makeReportLink',
    method: 'post',
    data: {
      url,
      overdueTime,
      examId,
      phone,
      report,
      study_id
    }
  }).catch(defaultRequestErrorHandle)
}

export function getReportByCode({
  id,
  code,
  short,
  isEncrypt,
  isAnonymous
}) {
  return service({
    url: '/getReportByCode',
    method: 'post',
    data: {
      id,
      code,
      short,
      isEncrypt,
      isAnonymous
    }
  }).catch(defaultRequestErrorHandle)
}

// 数字影像支付
export function ready2pay({
  id,
  openid
}) {
  return service({
    url: '/ready2FilmPay',
    method: 'post',
    data: {
      id,
      openid
    }
  }).catch(defaultRequestErrorHandle)
}

export function getLocalReport({
  id
}) {
  return service({
    url: '/getLocalReport',
    method: 'post',
    data: {
      id
    }
  }).catch(defaultRequestErrorHandle)
}
export function getRemoteReport({
  id
}) {
  return service({
    url: '/getRemoteReport',
    method: 'post',
    data: {
      id
    }
  }).catch(defaultRequestErrorHandle)
}
export function getAllRemote() {
  return service({
    url: '/getAllRemote',
    method: 'post',
    data: {

    }
  }).catch(defaultRequestErrorHandle)
}

export function getOneReport({
  id
}) {
  return service({
    url: '/getOneReport',
    method: 'post',
    data: {
      id
    }
  }).catch(defaultRequestErrorHandle)
}

export function ready2RemotePay({
  id,
  openid
}) {
  return service({
    url: 'ready2RemotePay',
    method: 'post',
    data: {
      id,
      openid
    }
  }).catch(defaultRequestErrorHandle)
}
//解绑
export function getUnBind({
  exam_id,
  phone
}) {
  return service({
    url: '/unBind',
    method: 'post',
    data: {
      exam_id,
      phone
    }
  }).catch(defaultRequestErrorHandle)
}
export function getVideo({ exam_id }) {
  return service({
    url: '/getVideo',
    method: 'post',
    data: {
      exam_id
    }
  }).catch(defaultRequestErrorHandle)
}
export function getAttachment({ exam_id ,exam_datetime,code }) {
  return service({
    url: '/getAttachment',
    method: 'post',
    data: {
      exam_id,
      exam_datetime,
      code
    }
  }).catch(defaultRequestErrorHandle)
}
export function getReportAnnex({ exam_id }) {
  return service({
    url: '/getReportAnnex',
    method: 'post',
    data: {
      exam_id
    }
  }).catch(defaultRequestErrorHandle)
}
export function getField({institution_id}) {
  return service({
    url: "/dock/getField",
    method: "post",
    data: {
      institution_id
    },
  }).catch(defaultRequestErrorHandle);
}
export function sendEmail({study_id, email}) {
  return service({
    url: "/sendEmail",
    method: "post",
    data: {
      study_id,
      email
    },
  }).catch(defaultRequestErrorHandle);
}
// 获取支付
export function getPayData({institution_id, exam_id}) {
  return service({
    url: "/dock/getPayData",
    method: "post",
    data: {
      institution_id,
      exam_id
    },
  }).catch(defaultRequestErrorHandle);
}

export function getAnnex({exam_id}) {
  return service({
    url: "/dock/getAnnex",
    method: "post",
    data: {
      exam_id
    },
  }).catch(defaultRequestErrorHandle);
}

export function getAiSuggest({exam_id}) {
  return service({
    url: "/getAiSuggest",
    method: "post",
    data: {
      exam_id
    },
  }).catch(defaultRequestErrorHandle);
}

export function getSwitch({exam_id}) {
  return service({
    url: "/dock/getSwitch",
    method: "post",
    data: {
      exam_id
    },
  }).catch(defaultRequestErrorHandle);
}

export function getSaveInterpretLog({id, type, source}) {
  return service({
    url: "/saveInterpretLog",
    method: "post",
    data: {
      id,
      type,
      source
    },
  }).catch(defaultRequestErrorHandle);
}

export function saveVisitLog({id, type, openid}) {
  return service({
    url: "/saveVisitLog",
    method: "post",
    data: {
      id,
      type,
      openid
    },
  }).catch(defaultRequestErrorHandle);
}

// 帅总 公众号推送 肺部健康守护计划
export function saveWechatLog({id, openid}) {
  return service({
    url: "/saveWechatLog",
    method: "post",
    data: {
      id,
      openid
    },
  }).catch(defaultRequestErrorHandle);
}
